import moment from 'moment'
import {getList} from '../../api/base_entity'


export default {
    "title": "Formazione",
    "entityName": "training",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    filterStorage: {},
    "fields": [
        {
            "value": "type",
            "text": "Tipo",
            "type": "list",
            "list" : ['webinar', 'workshop', 'educational', 'family & friends', 'meeting'],
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
        },

        {
            "value": "training_categories",
            "reference": "training_category",
            "id": "id",
            "text": "Categoria",
            "title" : "name",
            multiple: true,
            "type": "autocomplete",
            // "table": {
            //     "sortable": true,
            //     "filter": true
            // },
            "validators": [
                // "required"
            ],
        },

        {
            "value": "countries",
            "reference": "country",
            "id": "id",
            "text": "Countries",
            "title" : "name",
            multiple: true,
            "type": "autocomplete",
            // "table": {
            //     "sortable": true,
            //     "filter": true
            // },
            "validators": [
                // "required"
            ],
        },
        
        {
            "value": "regions",
            "reference": "region",
            "id": "id",
            "text": "Regions",
            "title" : "name",
            multiple: true,
            "type": "autocomplete",
            // "table": {
            //     "sortable": true,
            //     "filter": true
            // },
            "validators": [
                // "required"
            ],
        },

        {
            full:true,
            "value": "tag",
            "text": "Tag",
            "type": "list",
            "list" : ['Academy', 'Broadcast', 'Business', 'Cataloghiamoci'],
            // "table": {
            //     "sortable": true,
            //     "filter": true
            // },
            "validators": [
                // "required"
            ],
        },


        {
            full:true,
            "value": "title",
            "text": "Titolo",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
        },

        {
            full:true,
            "value": "text",
            "text": "Testo",
            "type": "textarea",
            "validators": [
            ],
        },

        {
            md6:true,
            "value": "dateFrom",
            "text": "Date From",
            "type": "datetime",
            "table": {
                "sortable": true,
                "filter": true
            },
            render: (item) => { return moment(item.dateFrom).format('DD/MM/YYYY H:mm')},
            filter: (filters, search) => { return { 'dateFrom' : `>=${search}`} },
            "validators": [
                "required"
            ],
        },

        {
            md6:true,
            "value": "dateUntil",
            "text": "Date To",
            "type": "datetime",
            "table": {
                "sortable": true,
                "filter": true
            },
            render: (item) => { return moment(item.dateUntil).format('DD/MM/YYYY H:mm')},
            filter: (filters, search) => { return { 'dateUntil' : `<=${search}`} },
            "validators": [
                "required"
            ],
        },

        // {
        //     full:true,
        //     "value": "managers",
        //     "text": "Managers",
        //     "title": "name",
        //     "type": "text",
        //     "table": {
        //         "sortable": true,
        //         "filter": true
        //     },
        //     "validators": [
        //         "required",
        //     ],
        //     // render: (item) => {
        //     //     return item.country.name + " (" + item.country.code + ")" 
        //     // },
        // },


        {
            value: 'staff',
            text: 'Staff',
            "id": "id",
            title: (item) => {return item.surname + ' ' + item.name},
            subtitle: (item) => {return item.role},
            multiple:true,
            // return_object:true,
            deletable_chips:true,
            chips:true,
            'type': 'autocomplete',
            list: async (item, search) => { return await getList('staff', [{name: "%" + (search ? search : '') + "%"},{surname: "%" + (search ? search : '') + "%"}], {rowsPerPage: -1, sortBy: 'surname'}) }
        },

        {
            "value": "collaborations",
            "text": "Collaborations",
            "type": "text",
            "validators": [
            ],
        },


        {
            full:true,
            "value": "link",
            "text": "Link iscrizione",
            "type": "text",
            "validators": [
            ],
        },

        {
            full:true,
            "value": "webinar_source",
            "text": "Link Sorgente Webinar",
            deps: ['type'],
            visible: item => item.type == 'webinar',
            "type": "text",
            "validators": [
            ],
        },




    ],
    "actions": [
        'upsert','remove'
    ]
}